import { dashboardTour } from "./dashboardTour";
import { transactionTour } from "./transactionTour";
import { userManagementTour } from "./userManagementTour";

export const tours = {
  dashboard: dashboardTour,
  users: userManagementTour,
  transaction: transactionTour,
};